export default "__VITE_ASSET__CQFWBXib__"